"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class KeyStrokeFactory {
    /**
     * Parse `ctrl+alt+shift+J` string into a KeyStroke obj
     */
    static fromString(value) {
        const keyStroke = { ctrl: false, alt: false, shift: false, key: null };
        value.toLowerCase().split('+').forEach((key) => {
            key = key.trim();
            if (key === 'ctrl') {
                keyStroke.ctrl = true;
            }
            else if (key === 'alt') {
                keyStroke.alt = true;
            }
            else if (key === 'shift') {
                keyStroke.shift = true;
            }
            else {
                if (keyStroke.key !== null) {
                    throw new Error('KeyStrokeFactory: Invalid keystroke: ' + value);
                }
                keyStroke.key = key;
            }
        });
        return keyStroke;
    }
}
exports.default = KeyStrokeFactory;
//# sourceMappingURL=KeyStrokeFactory.js.map